var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { QueryErrorResetBoundary } from 'react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { Alert, Button, CircularProgress } from '@mui/material';
export var StatusBoundary = function (_a) {
    var children = _a.children, _b = _a.fallback, fallback = _b === void 0 ? (_jsx("div", __assign({ className: "grid min-h-widget place-items-center" }, { children: _jsx(CircularProgress, {}) }))) : _b;
    return (_jsx(Suspense, __assign({ fallback: fallback }, { children: _jsx(QueryErrorResetBoundary, { children: function (_a) {
                var reset = _a.reset;
                return (_jsx(ErrorBoundary, __assign({ onReset: reset, fallbackRender: function (_a) {
                        var resetErrorBoundary = _a.resetErrorBoundary;
                        return (_jsxs("div", __assign({ className: "grid gap-4 min-h-widget place-content-center" }, { children: [_jsx(Alert, __assign({ severity: "error" }, { children: "Oops! An error occurred" })), _jsx(Button, __assign({ className: "mx-auto", onClick: function () { return resetErrorBoundary(); } }, { children: "Retry" }))] })));
                    } }, { children: children })));
            } }) })));
};
